<template>
  <section class="hashtag">
    <div class="title">
      <span>A state</span>
      <br />
      <span>&nbsp;&nbsp;-ment</span>
      <br />
      <span>of disagree</span>
      <br />
      <span>&nbsp;&nbsp;&nbsp;&nbsp;-ment.</span>
    </div>
    <div class="tag">
      <span class="bracket">[</span>
      <span class="hash">#</span>
      <span class="violence">VIOLENCE</span>
      <span class="isnot">isnotmyculture</span>
      <span class="bracket">]</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HashtagSession',
};
</script>

<style lang="scss" scoped>
.page section.hashtag {
  padding-top: 300px;

  @include mq($until: ipadP) {
    padding-top: 150px;
  }
}

.hashtag {
  .title {
    padding-left: 100px;
    padding-right: 100px;
    font-size: rem(350px);
    font-size: calc(350px * var(--rw));
    line-height: rem(300px);
    line-height: calc(300px * var(--rw));
    visibility: hidden;

    @include mq($until: ipadL) {
      padding-left: 50px;
      font-size: rem(160px);
      line-height: rem(130px);
    }

    @include mq($until: ipadP) {
      font-size: rem(100px);
      line-height: rem(80px);
      padding-left: 20px;
    }
  }

  .tag {
    font-family: 'GT America Expanded';
    font-size: rem(70px);
    font-size: calc(70px * var(--rw));
    text-align: center;
    margin-top: 200px;
    margin-top: calc(200px * var(--rw));

    @include mq($until: ipadL) {
      font-size: rem(46px);
    }

    @include mq($until: ipadP) {
      font-size: rem(24px);
      margin-top: 80px;
    }

    .bracket {
      font-family: 'GT America';
      font-weight: 800;
      color: $color-primary;
    }

    .isnot, .hash {
      -webkit-text-fill-color: transparent;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: $color-primary;
    }
  }
}
</style>
